import { SocieteCaracteristiqueToHandle } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const SocieteCaracteristiqueActions = createActionGroup({
  source: 'Societe Caracteristique',
  events: {
    'Handle Many Societe Caracteristiques': props<SocieteCaracteristiqueToHandle>()
  }
});
